import React from "react";
import AdminHeader from "./AdminHeader";
import AdminNavbar from "./AdminNavbar";
import { Link } from "react-router-dom";
const ActivityLog = () => {
  return (
    <div className="bg-[#f0ece1] fixed_width">
      <AdminHeader />
      <AdminNavbar />
      <div className=" container">
        <div className=" w-[50%]  ml-4 py-2 mt-2">
          <button className="border-1 bg-[#fff] border-gray-400 px-2 py-[8px]">
            <span className="bg-orange-400 text-[13px] rounded-[5px] mr-2 px-[10px] py-[0px]]">
              A
            </span>
            <span className="font-bold">admin</span>
          </button>
          <button className="border-1 bg-[#fff] border-gray-400 px-2 py-[8px]">
            <span className="bg-red-500 rounded-[5px] text-[13px] mr-2 px-[10px] py-[0px]]">
              SAU
            </span>
            <span className="font-bold">tarikul</span>
          </button>
          <button className="border-1 bg-[#fff] border-gray-400 px-2 py-[8px]">
            <span className="bg-yellow-400 text-[13px] rounded-[5px] mr-2 px-[10px] py-[0px]]">
              A
            </span>
            <span className="font-bold">admin</span>
          </button>
          <button className="border-1 bg-[#fff] border-gray-400 px-2 py-[8px]">
            <span className="bg-green-400 text-[13px] rounded-[5px] mr-2 px-[10px] py-[0px]]">
              A
            </span>
            <span className="font-bold">admin</span>
          </button>
          <button className="border-1 bg-[#fff] border-gray-400 px-2 py-[8px]">
            <span className="bg-blue-400 text-[13px] rounded-[5px] mr-2 px-[10px] py-[0px]]">
              A
            </span>
            <span className="font-bold">admin</span>
          </button>
          <button className="border-1 bg-[#fff] border-gray-400 px-2 py-[8px]">
            <span className="bg-purple-400 text-[13px] rounded-[5px] mr-2 px-[10px] py-[0px]]">
              A
            </span>
            <span className="font-bold">admin</span>
          </button>
        </div>
        <div className="bg-[#f0ece1] h-[100vh] flex  ">
          <div className=" w-[18%]">
            <div className="restore_indisde_heading ml-3 mt-4 rounded-sm  bg-gradient-to-t from-blue-900 to-blue-950">
              <p className="text-white  ml-2 font-bold p-1">Positions</p>
            </div>
            <div className="w-[98%]  ml-2">
              <ul>
                <li className=" bg-white border-none py-1 hover:bg-gray-400  font-normal text-[15px]">
                  <Link to={"/Aaccountstatement"}>Account Statement</Link>
                </li>
                <li className=" bg-white border-none py-1 hover:bg-gray-400  font-normal text-[15px]">
                  <Link to={"/Aaccountstatement"}>Account Summaary</Link>
                </li>
                <li className=" bg-white border-none py-1 hover:bg-gray-400  font-normal text-[15px]">
                  Activity Log
                </li>
              </ul>
            </div>
            <div className="restore_indisde_heading ml-3  rounded-sm  bg-gradient-to-t from-blue-900 to-blue-950">
              <p className="text-white  ml-2 font-bold p-1">Accounts Details</p>
            </div>
            <div className="w-[98%]  ml-2">
              <ul>
                <li className=" bg-white border-none py-1 hover:bg-gray-400  font-normal text-[15px]">
                  <Link to={"/Aaccountstatement"}>Profile </Link>
                </li>
                <li className=" bg-white border-none py-1 hover:bg-gray-400  font-normal text-[15px]">
                  <Link to={"/Aaccountstatement"}>Activity log </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="right w-[70%]">
            <div className="account_main   mt-4 ">
              <div className="balance_overview   ml-5 ">
                <div className="account_profile mt-3">
                  <div className="main_account">
                    <h1 className=" p-1 ml-1 text-[24px] text-black font-bold">
                      Activity Log
                    </h1>
                    <div className="flex flex-col">
                      <div className="overflow-x-auto">
                        <div className="p-1.5 w-full inline-block align-middle">
                          <div className="overflow-hidden border border-black">
                            <table className="min-w-full divide-y divide-gray-200">
                              <thead className="bg-gray-300 text-black">
                                <tr>
                                  <th
                                    scope="col"
                                    className="px-6 py-3 text-xs font-bold text-left  uppercase "
                                  >
                                    Login Date & Time
                                  </th>
                                  <th
                                    scope="col"
                                    colSpan="1"
                                    className="px-6 py-3 text-xs font-bold text-left  uppercase "
                                  >
                                    Login Status
                                  </th>
                                  <th
                                    scope="col"
                                    colSpan="3"
                                    className="px-6 py-3 text-xs font-bold text-left  uppercase "
                                  >
                                    IP Address
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-6 py-3 text-xs font-bold text-right  uppercase "
                                  >
                                    ISP
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-6 py-3 text-xs font-bold text-right  uppercase "
                                  >
                                    City/State/Country
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-6 py-3 text-xs font-bold text-right  uppercase "
                                  >
                                    User Agent Type
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y bg-[#fff] divide-gray-200">
                                <tr>
                                  <td
                                    colSpan="0"
                                    className="px-6 py-4 text-sm font-medium text-gray-800 whitespace-nowrap"
                                  >
                                    3
                                  </td>
                                  <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
                                    Jone Doe
                                  </td>
                                  <td
                                    colSpan="1"
                                    className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap"
                                  >
                                    jonne62@gmail.com
                                  </td>
                                  <td
                                    colSpan="4"
                                    className="px-6 py-4 text-sm font-medium text-right whitespace-nowrap"
                                  >
                                    <a
                                      className="text-green-500 hover:text-green-700"
                                      href="#"
                                    >
                                      Edit
                                    </a>
                                  </td>
                                  <td className="px-6 py-4 text-sm font-medium text-right whitespace-nowrap">
                                    <a
                                      className="text-red-500 hover:text-red-700"
                                      href="#"
                                    >
                                      Delete
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityLog;
